{
  "instances": {
    "loggers": {
      "label": "Loggers",
      "application": "Application",
      "fetch_failed_some_instances": "Fetching loggers for {failed} of {count} instances failed. Configuring loggers for those are likely to fail.",
      "filter": {
        "class_only": "class only",
        "configured": "configured"
      },
      "group": {
        "label": "Logging Groups"
      },
      "instance": "Instance",
      "new": "new",
      "no_loggers_found": "No loggers found.",
      "unset": "Unset",
      "setting_loglevel_failed": "Setting {logger} to {loglevel} failed."
    }
  }
}
